import React from "react";
import classNames from "classnames";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";

import Typography from "@/shared/components/Typography/Typography";
import IconView from "@/shared/components/IconView/IconView";

import { removeBR } from "@/shared/utils/content/content";
import EgwWebFont from "@/shared/assets/EgwWebFont";

import styles from "./BreadcrumbsButtonGoBack.module.scss";

const BreadcrumbsButtonGoBack = ({
  className,
  title,
  disabled,
  showIconBack = true,
  isTranslateLabel = true,
  nsSeparator = false,
  onGoBack,
  folderType,
}) => {
  const { t } = useSharedTranslation();

  let labelFinal;
  if (isTranslateLabel) {
    labelFinal = removeBR(t(title, {
      // prevent labels with a colon (":")
      // being considered as the {[namespace]:[key]}
      nsSeparator: nsSeparator ? undefined : false,
    }));
  } else {
    labelFinal = title;
  }

  return (
    <button
      className={classNames(styles["root"], folderType, className)}
      disabled={disabled}
      onClick={disabled ? undefined : onGoBack}
    >
      <Typography variant="h2" className={styles["title-wrap"]}>
        {showIconBack && (
          <IconView className={styles["icon"]} icon={EgwWebFont["chevron-left"]} />
        )}
        <Typography
          className={styles["title"]}
          threeDots
          fontFamily={Typography.fontFamily.bebas}
        >{labelFinal}</Typography>
      </Typography>
    </button>
  );
};

export default BreadcrumbsButtonGoBack;
